import OrganizationService from "../services/OrganizationService";

export const fetchCurrentDate=()=>{
    //based on org timezone
    const orgTimeZone = OrganizationService.getOrgTimeZone();    
    return new Date(new Date().toLocaleString('en-US',{ timeZone: orgTimeZone}));
   }